import { render, staticRenderFns } from "./PageDivider.vue?vue&type=template&id=7df11d2c&scoped=true&"
import script from "./PageDivider.vue?vue&type=script&lang=js&"
export * from "./PageDivider.vue?vue&type=script&lang=js&"
import style0 from "./PageDivider.vue?vue&type=style&index=0&id=7df11d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df11d2c",
  null
  
)

export default component.exports